import React from "react";
import "./styles.scss";
import NavBar from "../../Components/NavBar";
import ScrollAnimation from "react-animate-on-scroll";

const Landing: React.FC = () => {
    const HERO_IMAGE = require("../../Assets/images/Banner.png");

    return (
        <div className="landing__wrapper">
            <NavBar />

            <div className="landing__hero">
                <div className="container">
                    <ScrollAnimation animateIn="bounceInLeft">
                        <div className="hero__info">
                            <h2 className="tt-title title-bold">
                                Controle de Ponto On-Line Artesynal
                            </h2>
                            <p>
                                É um prazer enorme saber que você está acessando essa página, afinal são muitos anos nos organizando para neste momento ter você em nossa equipe, utilize este aplicativo de forma responsável e lembre-se, não basta trabalhar é necessário transformar, mudar e evoluir sempre!
                            </p>

                            <div className="info__contact">
                                <a
                                    className="bt whatsapp"
                                    href="https://wa.me/554136634017?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20acesso%20ao%20sistema%20MarcaPonto"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Solicite seu acesso
                                </a>
                            </div>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation animateIn="bounceInRight">
                        <div className="hero__image">
                            <img src={HERO_IMAGE} alt="MarcaPonto" />
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    );
};
export default Landing;
